import { createMemo } from "solid-js"
import dijkstraDirectionCharsLowerCase from "../../lib/core/direction/dijkstraDirectionCharsLowerCase"
import type { RiverEntity } from "../../lib/core/entity/EntityType/River"
import isEntityTypeIdRiverExit from "../../lib/core/entity/isEntityTypeIdRiverExit"
import isIdListSame from "../signal/equals/isIdListSame"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { createSharedTileGraphNodeCollectionMemo } from "./createSharedTileGraphNodeCollectionMemo"
import useGridWidthHeight from "./useGridWidthHeight"
import { useSharedRiverEntsListMemo } from "./useSharedRiverEntsListMemo"
import { useSharedTerrainLayer1EntityTypeIdOrZeroArrayMemo } from "./useSharedTerrainLayer1EntityTypeIdOrZeroArrayMemo"

// return all river water ents
export const useSharedRiverExitEntsListMemo = createSharedCachedFactory((engine) => {
  const getGridSize = useGridWidthHeight(engine)
  const getTileGraphNodesList = createSharedTileGraphNodeCollectionMemo(engine)
  const getTerrainLayer1EntityTypeIdOrZeroArray = useSharedTerrainLayer1EntityTypeIdOrZeroArrayMemo(engine)
  // const getWaterEntsList = useSharedWaterEntsListMemo(engine)
  const getRiverEntsList = useSharedRiverEntsListMemo(engine)

  const getRiverExitEntsList = createMemo<Array<RiverEntity>>(() => {
    const { width } = getGridSize()
    const tpNodeList = getTileGraphNodesList()
    const riverEntList = getRiverEntsList()
    const terrainLayer1EntityTypeIdOrZeroArray = getTerrainLayer1EntityTypeIdOrZeroArray()
    const exitTiles: RiverEntity[] = []

    for (const riverEnt of riverEntList) {
      const nodeIndex0 = riverEnt.x + (riverEnt.y * width)
      const node0 = tpNodeList[nodeIndex0]

      for (const dirChar of dijkstraDirectionCharsLowerCase) {
        const node1 = node0[dirChar]
        if (node1) {
          const nodeIndex1 = node1.index
          const terrainEntityTypeId = terrainLayer1EntityTypeIdOrZeroArray[nodeIndex1]
          if (isEntityTypeIdRiverExit(terrainEntityTypeId)) {
            exitTiles.push(riverEnt)
            break
          }
        }
      }
    }

    return exitTiles
  }, [], {
    equals: isIdListSame,
  })

  // createEffect(() => {
  //   console.log('RiverExitEntsList', getRiverExitEntsList())
  // })

  return getRiverExitEntsList
})
